import { Button, Stack, Divider } from "@mui/material"
import { SetupType } from "@/gluelayer"
import { SetupByRx } from "../../UDesign/UDSetupType"
export const WeSetupType = (props) => {
  const setupTypeAndStr = [
    [SetupType.Full, "Auto"],
    [SetupType.Anterior, "Anterior"],
    [SetupType.FullNoAP, "Molar to Molar"],
    [SetupType.Full, "Full Arch"],
    [SetupType.Anterior, "Upper Only"],
    [SetupType.Anterior, "Lower Only"],
    [SetupType.FineTune, "Fine Tune"],
    [SetupType.AlignmentOnly, "Alignment Only"],
    [SetupType.Aligner5, "Aligner 5"],
    [SetupType.Init, "Init"],
  ]
  return (
    <Stack>
      <SetupByRx setupTypeAndStr={setupTypeAndStr} />
      <Divider />
    </Stack>
  )
}
